"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  quote: "Wanderlust Expeditions curated the most breathtaking trek through the Andes. Every detail was handled with expert precision.",
  author: "Elena Rodriguez",
  position: "Adventure Enthusiast",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/traveler_elena.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/traveler_elena.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/traveler_elena.png-wvc-sizes"
}, {
  quote: "The tropical getaway they planned for us was pure magic. The teal waters and golden sands were exactly as promised.",
  author: "David Chen",
  position: "Frequent Explorer",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/traveler_david.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/traveler_david.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/traveler_david.png-wvc-sizes"
}];
export default function VoicesOfTheRoad() {
  return <section data-section-id="264235" id="voices-of-the-road" className="relative overflow-hidden bg-background text-foreground py-24 md:py-32">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none flex items-center justify-center z-0">
        <div className="absolute w-[60vw] h-[60vw] max-w-[800px] max-h-[800px] bg-primary/10 rounded-lg blur-[100px] animate-pulse" style={{
        animationDuration: "10s"
      }} />
        <div className="absolute w-[50vw] h-[70vw] max-w-[600px] max-h-[900px] bg-primary/5 rounded-lg blur-[120px] animate-pulse" style={{
        animationDuration: "15s",
        animationDelay: "2s"
      }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <Carousel opts={{
        loop: true,
        align: "center"
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <div className="flex flex-col items-center justify-center px-4 py-8 md:px-16">
                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, i) => <span key={i} className="text-primary text-xl"></span>)}
                  </div>
                  <blockquote className="mb-12 max-w-4xl text-center">
                    <p className="font-serif text-[2rem] md:text-[2.5rem] leading-tight italic text-foreground tracking-tight">
                      "{testimonial.quote}"
                    </p>
                  </blockquote>

                  <div className="flex flex-col items-center gap-4">
                    <SafeHydrate><Avatar className="size-16 border border-primary/20 shadow-md">
                      <AvatarImage src={testimonial.avatar} data-wvc-srcset={testimonial.srcset} data-wvc-sizes={testimonial.sizes} alt={testimonial.author} loading="lazy" />
                      <AvatarFallback className="font-default text-lg bg-primary text-primary-foreground">
                        {testimonial.author.charAt(0)}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div className="text-center">
                      <div className="font-default font-bold text-foreground text-lg uppercase tracking-wider">
                        {testimonial.author}
                      </div>
                      <div className="font-mono text-xs text-muted-foreground mt-0.5 uppercase">
                        {testimonial.position}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="hidden md:block">
            <CarouselPrevious className="border border-border bg-background/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground size-12 -left-4 lg:-left-12 transition-colors" />
            <CarouselNext className="border border-border bg-background/80 backdrop-blur-md hover:bg-primary hover:text-primary-foreground size-12 -right-4 lg:-right-12 transition-colors" />
          </div>
        </Carousel>
      </div>
    </section>;
}